import {
  AspectRatio,
  Box,
  Button,
  Icon,
  Text,
  useBreakpointValue,
} from "@chakra-ui/react";
import EmptyNftCard, { EmptyNftCardProps } from "components/EmptyNftCard";
import { theme } from "config";
import { FaExternalLinkAlt } from "react-icons/fa";
import { hexToRGB } from "utils/colorUtils";

type EmptyNftCardWithLinkProps = EmptyNftCardProps & {
  label: string;
  externalUrl: string;
};

const EmptyNftCardWithLink = ({
  label,
  externalUrl,
  ...rest
}: EmptyNftCardWithLinkProps) => {
  const buttonSize = useBreakpointValue({
    base: "xs",
    sm: "sm",
  });

  return (
    <EmptyNftCard position="relative" {...rest}>
      <AspectRatio
        position="absolute"
        zIndex={1}
        top="1.5"
        left="1.5"
        right="1.5"
        ratio={1}
      >
        <Box w="full" h="full" textAlign="center" position="relative">
          <Button
            position="absolute"
            colorScheme="dark"
            as="a"
            bottom="0"
            w="full"
            borderTopRadius="0"
            href={externalUrl}
            target="_blank"
            rel="noreferrer"
            flexShrink="0"
            size={buttonSize}
            cursor="pointer"
            rightIcon={<Icon as={FaExternalLinkAlt} />}
            bg={hexToRGB(theme.colors.dark[600], 0.8)}
          >
            {label}
          </Button>
        </Box>
      </AspectRatio>

      <Text fontWeight="600" px="1.5" pt="1.5">
        #???
      </Text>
    </EmptyNftCard>
  );
};

export default EmptyNftCardWithLink;
